import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { CONTACT } from "../../lib/site";
import { useWhatsApp } from "../WhatsAppProvider";

const links = [
  { label: "Offerte", href: "#offerte-mobile" },
  { label: "Fibra", href: "#fibra" },
  { label: "Luce & Gas", href: "#luce-gas" },
  { label: "Telefoni", href: "#telefoni" },
  { label: "Partite IVA", href: "#business" },
  { label: "Perché noi", href: "#perche-noi" },
  { label: "Contatti", href: "#contatti" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { openPicker } = useWhatsApp();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-300 ${
        scrolled ? "bg-black/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="font-display font-extrabold text-2xl tracking-tight text-white">
          wind<span className="text-brand">online</span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className="text-sm font-medium text-white/70 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${CONTACT.phonePrimary.tel}`}
            data-testid="header-call-btn"
            className="inline-flex items-center gap-2 text-sm font-semibold text-white/90 hover:text-white transition-colors"
          >
            <Phone className="w-4 h-4" /> {CONTACT.phonePrimary.label}
          </a>
          <button
            type="button"
            onClick={() => openPicker()}
            data-testid="header-whatsapp-btn"
            className="inline-flex items-center rounded-full bg-brand hover:bg-brand-hover text-white text-sm font-semibold px-5 py-2.5 transition-colors duration-200"
          >
            WhatsApp
          </button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-4">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-white/80 text-lg font-medium py-1">
              {l.label}
            </a>
          ))}
          <button type="button" onClick={() => { setOpen(false); openPicker(); }} className="mt-2 text-center rounded-full bg-brand text-white font-semibold py-3">
            Scrivici su WhatsApp
          </button>
        </div>
      )}
    </header>
  );
};
